/** Serializes the theme's fetch-based cart writes, including third-party forms.
 * A transaction reserves its before/write/after reads as one queue entry.
 * Never retries a mutation. Does not change Shopify requests or responses.
 */
(() => {
  if (window.deinFriseurCartQueue) return;
  const nativeFetch = window.fetch.bind(window);
  let tail = Promise.resolve();
  const run = (task) => {
    const result = tail.then(() => task(nativeFetch));
    tail = result.catch(() => {});
    return result;
  };
  window.deinFriseurCartQueue = { run };
  window.fetch = function (input, options) {
    const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href);
    const method = options?.method || (input instanceof Request ? input.method : 'GET');
    if (url.origin === location.origin && method.toUpperCase() === 'POST' && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname)) {
      return run(async (fetch) => {
        try {
          const response = await fetch(input, options);
          // Keep subsequent mutations behind receipt of the complete response body.
          await response.clone().text();
          return response;
        } finally {
          document.dispatchEvent(new Event('cart:mutation-settled'));
        }
      });
    }
    return nativeFetch(input, options);
  };
})();
